import React, { Component } from 'react';
import Header from '../Header/HeaderContainer';
import Stage from '../Stage/StageContainer';
import Scenes from '../Scenes/Scenes';
import Curtain from '../Curtain/Curtain';
import Footer from '../Footer/FooterContainer';
import User from '../User/UserContainer';

class App extends Component {
  render() {
    return (
      <div id="main">
        <User />
        <Curtain />
        <Header />
        <Stage />
        <Scenes />
        <Footer />
      </div>
    );
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/components/App/App.js
 **/